// extracted by mini-css-extract-plugin
export var addressFields = "_gc-0";
export var animationContainer = "_gc-1";
export var footer = "_gc-2";
export var lineItems = "_gc-3";
export var modalContent = "_gc-4";
export var orderName = "_gc-5";
export var strong = "_gc-6";
export var warning = "_gc-7";